import { Navigate } from "react-router-dom"

import { useCountryOlympicsLocked } from "../hooks/useCountryOlympicsLocked"

/**
 * TEMP: keeps the locked Health subpages unreachable by direct URL.
 *
 * `main-info` is not persisted and these subpages never request it, so on a direct
 * hit the flag is simply unknown — the hook decides how that case is treated.
 * Sends the user back to the Health overview, where the blocks render locked.
 *
 * To remove: delete this file and unwrap the routes in InternalPages.js.
 */
const CountryOlympicsGuard = ({ children }) => {
  const isLocked = useCountryOlympicsLocked()

  if (isLocked) return <Navigate to=".." replace={true} />

  return children
}

export default CountryOlympicsGuard
